import { PermissionsScope } from '../policies/policy.model'

export const CATEGORY_SCOPE: PermissionsScope = 'categories'
